import React, { Component } from "react"
import { Table, message, Row } from "antd"
import { observer, inject } from "mobx-react"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import WarningTip from "app/components/normal/WarningTip/WarningTip"
import { disposeFileSize } from "app/vendor/util"
import ellipsisDispose from "app/utils/ellipsisDispose"
import copyText from "app/utils/copyText"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import FlexableFileName from "app/components/normal/FlexableFileName"
import recoveryIcon from "app/styles/images/sp/recovery.svg"
import { PREPARE_RUN, RUNNING, SUCCESS, FAIL } from 'app/utils/const'

const ObserverTable = observer(({ store, task, index }) => {
  const columns = [
    {
      title: "关系",
      dataIndex: "relationName",
      key: "history-relationName",
      width: "14.6%",
      render: (text, record, index) => {
        const obj = {
          children: text,
          props: {
            rowSpan: 1
          },
        }
        let endIndex

        // 相同样本名的数量
        const sameCount = task.datas.filter(item => {
          endIndex = index
          return item.relationName === text
        }).length

        // 这个样本名的起始index
        const startIndex = task.datas.findIndex(item =>
          item.relationName === text
        )

        /*
         * 如果相同样本名的数量大于1
         * 1. 第一个做单元格合并
         * 2. 其余设置rowSpan为0
         * 不大于1正常渲染即可
         */
        if (sameCount > 1 && index <= endIndex) {
          if (index === startIndex) {
            obj.props.rowSpan = sameCount
          } else {
            obj.props.rowSpan = 0
          }
        }

        return obj
      }
    },
    {
      title: "文件名称",
      dataIndex: "filename",
      key: "history-filename",
      width: "28.97%",
      render: (text) => {
        const { queryMap: { keywords } } = store

        return (
          <FlexableFileName filename={text} keywords={keywords} matched={true} />
        )
      }
    },
    {
      title: "基因",
      dataIndex: "genes",
      key: "history-sampleName",
      width: "19.84%",
      render: (text) => {
        return (
          <MaterialTip
            title={text.toString()}
          >
            <div className="sample-name ellipsis">
              <Highlighter
                highlightClassName="lightlight"
                highlightStyle={{ fontWeight: "normal" }}
                searchWords={[]}
                textToHighlight={text.toString() || ""}
              />
            </div>
          </MaterialTip>
        )
      }
    },
  ]
  return (
    <Table
      className="children-table"
      columns={columns}
      rowKey={record => record.id + "datas"}
      dataSource={
        task.datas.slice()
      }
      pagination={false}
    />
  )
})

@inject("entrance", "auth") @observer
export default class ReportCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dataIndex: 0,
      groupNameHistory: [],
    }
    this.clickedInfo = {
      id: "",
      count: 0
    }
  }

  closeModal = (modal, cb) => {
    this.setState({
      [modal]: false
    })
    if (typeof cb === "function") {
      cb()
    }
  }

  showModal = (field) => {
    this.setState({
      [field]: true
    })
  }

  closeModal = (modal, cb = () => { }) => {
    this.setState({
      [modal]: false
    }, cb)
  }

  renderGroupName = () => {
    const { data = {} } = this.props
    const { groupNameHistory } = this.state
    const { queryMap: { keywords } } = this.props.store
    const groupName = (
      <MaterialTip
        title={data.groupName}
      >
        <div className="cursor-p ellipsis">
          <Highlighter
            highlightClassName="lightlight"
            highlightStyle={{ fontWeight: "normal" }}
            searchWords={highlightable(data.groupName, keywords) ? [data.groupName] : []}
            textToHighlight={data.groupName}
          />
        </div>
      </MaterialTip>
    )

    if (data.hasHistory) {
      return (
        <WarningTip
          type="warningTip"
          text={groupName}
          justify="start"
          overlayClassName="ta-c"
          mainKeys={["versionNum", "name", "createTime"]}
          historyData={groupNameHistory}
          onVisibleChange={this.toggleGroupNameHistory}
        />
      )
    } else {
      return (
        <div>{groupName}</div>
      )
    }
  }

  expandedRowRender = (task) => {
    const { index, store } = this.props
    return (
      <ObserverTable
        store={store}
        task={task}
        index={index} />
    )
  }

  toggleExpand = (expanded, { familyId, id }) => {
    const { index, store } = this.props
    if (expanded) {
      store.getTaskDatas(familyId, id)
        .then(
          res => {
            store.setTaskDatas(index, id, res)
          },
          err => new Promise(function (resolve, reject) {
            message.error(err.message)
          })
        )
    }
  }

  clickThreeTime = (id, cb) => {
    this.clickedInfo = {
      id,
      count: this.clickedInfo.count + 1
    }

    if (this.clickedInfo.id !== id) {
      this.clickedInfo = {
        id,
        count: 1
      }
    }

    if (this.clickedInfo.count > 2) {
      cb()
      this.initClickInfo()
    }
  }

  initClickInfo = () => {
    this.clickedInfo = {
      id: "",
      count: 0
    }
  }

  recoveryData = (record, index) => {
    const { store: { recoveryData }, data: { groupId } } = this.props
    recoveryData(groupId, record.reportId)
      .then(res => {
        this.props.data.reportList.splice(index, 1)
        message.success("报告恢复成功")
      }, err => {
        message.error(err.message)
      })
  }

  render() {
    const { data = {} } = this.props
    let reportList = data.reportList
    const columns = [
      {
        title: (<div className="ta-c">任务ID</div>),
        dataIndex: "id",
        width: "20.97%",
        render: (id) => {
          const { front, end } = ellipsisDispose(id)
          return (
            <MaterialTip
              title="点击三次复制完整任务ID"
              placement="bottom"
            >
              <Row
                className="ellipsis-wrapper cursor-p"
                type="flex"
                onClick={
                  () => this.clickThreeTime(
                    id,
                    () => copyText(id, "复制完整任务ID成功")
                  )
                }
              >
                <div className="ellipsis ellipsis-front">
                  {front}
                </div>
                <div className="ellipsis-end">{end}</div>
              </Row>
            </MaterialTip>
          )
        }
      }, {
        title: (<div className="ta-c">运行应用</div>),
        dataIndex: "appName",
        width: "9.62%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">应用版本</div>),
        dataIndex: "appVersion",
        width: "9.62%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">开始运行时间</div>),
        dataIndex: "startTime",
        width: "22.75%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">计算时间</div>),
        dataIndex: "computingTime",
        width: "10.62%",
        render: (text) => <div className="ta-c">{text}</div>
      }, {
        title: (<div className="ta-c">报告备注</div>),
        dataIndex: "remark",
        width: "20.62%",
        render: (text) => {
          return (
            <MaterialTip
              title={text}
            >
              <div className="ta-c ellipsis">{text}</div>
            </MaterialTip>
          )
        }
      }, {
        title: (<div className="ta-c">运行状态</div>),
        dataIndex: "state",
        width: "13.7%",
        render: (state, record) => {
          switch (state) {
            case PREPARE_RUN:
              return (
                <div className="ta-c">
                  <button className="pre-run">准备运行</button>
                </div>
              )
            case RUNNING:
              return (
                <div className="ta-c">
                  <button className="running">正在运行</button>
                </div>
              )
            case SUCCESS:
              return (
                <div className="ta-c">
                  <button className="report-view">查看报告</button>
                </div>
              )
            case FAIL:
              return (
                <MaterialTip
                  title="请将任务ID发送至管理员">
                  <div className="ta-c">
                    <button className="run-fail">运行失败</button>
                  </div>
                </MaterialTip>
              )
            default:
              break
          }
        }
      }, {
        title: (<div className="ta-c">操作</div>),
        dataIndex: "oprator",
        width: 50,
        render: (text, record, index) => {
          return (
            <Row className="table-oprator" type="flex" justify="center" align="middle">
              <img
                title="恢复"
                src={recoveryIcon}
                className="cursor-p"
                alt=""
                onClick={() => this.recoveryData(record, index)}
              />
            </Row>
          )
        }
      }
    ]

    return (
      <Row type="flex" className="report-card">
        <div className="card-left">
          <div className="content">
            <div className="info">
              <Row type="flex" justify="start" className="info-group">
                <label>数据类型：</label><p className="text-content">{data.appName}</p>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>所在家系：</label>
                <div className="text-content">
                  {this.renderGroupName()}
                </div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>文件数量：</label><p className="text-content">{data.dataCount}</p>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>数据大小：</label><p className="text-content">{disposeFileSize(data.totalSize)}</p>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>创建时间：</label><p className="text-content">{data.createTime}</p>
              </Row>
            </div>
          </div>
        </div>
        <Table columns={columns}
          className="task-table report-card-content"
          rowKey={record => record.id}
          onExpand={this.toggleExpand}
          expandedRowRender={this.expandedRowRender}
          dataSource={reportList.slice()}
          expandIconAsCell={false}
          pagination={false}
        />
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/arrayPgt/RecycleCard/index.js